import { FollowUpEntity } from '@/entities/FollowUp';

export const getTimestamp = (item: FollowUpEntity) => {
  const updated = item.updatedAt ? new Date(item.updatedAt).getTime() : null;
  const created = item.createdAt ? new Date(item.createdAt).getTime() : null;

  return updated ?? created ?? 0;
};
